import { useState, useEffect, useRef, useCallback } from 'react';
import './Galeria.css';

import img01 from '../../assets/img/img_01.jpeg';
import img02 from '../../assets/img/img_02.jpeg';
import img03 from '../../assets/img/img_03.jpeg';
import img04 from '../../assets/img/img_04.jpeg';
import img05 from '../../assets/img/img_05.jpeg';
import img06 from '../../assets/img/img_06.jpeg';
import img07 from '../../assets/img/img_07.jpeg';
import img08 from '../../assets/img/img_08.jpeg';
import img09 from '../../assets/img/img_09.jpeg';
import img10 from '../../assets/img/img_10.jpeg';
import img11 from '../../assets/img/img_11.jpeg';
import img12 from '../../assets/img/img_12.jpeg';
import img13 from '../../assets/img/img_13.jpeg';
import img14 from '../../assets/img/img_14.jpeg';
import img15 from '../../assets/img/img_15.jpeg';
import img16 from '../../assets/img/img_16.jpeg';
import img17 from '../../assets/img/img_17.jpeg';
import img18 from '../../assets/img/img_18.jpeg';
import img19 from '../../assets/img/img_19.jpeg';
import img20 from '../../assets/img/img_20.jpeg';
import img21 from '../../assets/img/img_21.jpeg';
import img22 from '../../assets/img/img_22.jpeg';
import img23 from '../../assets/img/img_23.jpeg';
import img24 from '../../assets/img/img_24.jpeg';
import img25 from '../../assets/img/img_25.jpeg';
import img26 from '../../assets/img/img_26.jpeg';
import img27 from '../../assets/img/img_27.jpeg';

const FOTOS = [
  { src: img17, alt: 'Gatinho da ONG Amanimal', legenda: 'Cada gatinho resgatado tem uma história de amor' },
  { src: img18, alt: 'Animal resgatado pela Amanimal', legenda: 'Um lar seguro enquanto aguardam uma família' },
  { src: img19, alt: 'Cuidados com os animais', legenda: 'Cuidado, carinho e muito amor em cada detalhe' },
  { src: img20, alt: 'Animal feliz na ONG', legenda: 'Felicidade que só o amor animal proporciona' },
  { src: img21, alt: 'Família de animais', legenda: 'Momentos que mostram nossa paixão pelos animais' },
  { src: img22, alt: 'Resgate de animal', legenda: 'Cada resgate é um novo começo cheio de esperança' },
  { src: img23, alt: 'Animal sendo cuidado', legenda: 'Amor e dedicação em cada momento' },
  { src: img24, alt: 'Animal da ONG Amanimal', legenda: 'Todos merecem uma segunda chance' },
  { src: img25, alt: 'Animais resgatados', legenda: 'Vidas transformadas pelo poder do amor' },
  { src: img26, alt: 'Animal recebendo carinho', legenda: 'O carinho que faz toda a diferença' },
  { src: img27, alt: 'Animal aguardando adoção', legenda: 'À espera de um lar cheio de afeto' },
  { src: img01, alt: 'Gatinho da ONG Amanimal', legenda: 'Cada gatinho resgatado tem uma história de amor' },
  { src: img02, alt: 'Animal resgatado pela Amanimal', legenda: 'Um lar seguro enquanto aguardam uma família' },
  { src: img03, alt: 'Cuidados com os animais', legenda: 'Cuidado, carinho e muito amor em cada detalhe' },
  { src: img04, alt: 'Animal feliz na ONG', legenda: 'Felicidade que só o amor animal proporciona' },
  { src: img05, alt: 'Família de animais', legenda: 'Momentos que mostram nossa paixão pelos animais' },
  { src: img06, alt: 'Resgate de animal', legenda: 'Cada resgate é um novo começo cheio de esperança' },
  { src: img07, alt: 'Animal sendo cuidado', legenda: 'Amor e dedicação em cada momento' },
  { src: img08, alt: 'Animal da ONG Amanimal', legenda: 'Todos merecem uma segunda chance' },
  { src: img09, alt: 'Animais resgatados', legenda: 'Vidas transformadas pelo poder do amor' },
  { src: img10, alt: 'Animal recebendo carinho', legenda: 'O carinho que faz toda a diferença' },
  { src: img11, alt: 'Animal aguardando adoção', legenda: 'À espera de um lar cheio de afeto' },
  { src: img12, alt: 'Voluntários e animais', legenda: 'Juntos fazemos mais por eles' },
  { src: img13, alt: 'Animal da ONG', legenda: 'Cada olhar conta uma história' },
  { src: img14, alt: 'Animal resgatado', legenda: 'Do abandono ao amor — essa é nossa missão' },
  { src: img15, alt: 'Animal feliz', legenda: 'Felicidade que contagia quem chega perto' },
  { src: img16, alt: 'Animal da Amanimal', legenda: 'Vista-se com propósito e salve vidas' },
];

export default function Galeria() {
  const [current, setCurrent] = useState(0);
  const timerRef = useRef(null);

  const goTo = useCallback((index) => {
    setCurrent((index + FOTOS.length) % FOTOS.length);
  }, []);

  const next = useCallback(() => goTo(current + 1), [current, goTo]);
  const prev = useCallback(() => goTo(current - 1), [current, goTo]);

  const resetTimer = useCallback(() => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setCurrent((c) => (c + 1) % FOTOS.length);
    }, 5000);
  }, []);

  useEffect(() => {
    resetTimer();
    return () => clearInterval(timerRef.current);
  }, [resetTimer]);

  /* Swipe touch */
  const touchStart = useRef(null);
  const onTouchStart = (e) => { touchStart.current = e.touches[0].clientX; };
  const onTouchEnd = (e) => {
    if (touchStart.current === null) return;
    const diff = touchStart.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      diff > 0 ? next() : prev();
      resetTimer();
    }
    touchStart.current = null;
  };

  const handlePrev = () => { prev(); resetTimer(); };
  const handleNext = () => { next(); resetTimer(); };

  return (
    <section id="galeria" className="galeria">
      <div className="galeria__header text-center">
        <span className="section-tag">Galeria</span>
        <h2 className="section-title">História com amor animal</h2>
        <p className="section-subtitle">Momentos que mostram nossa paixão</p>
      </div>

      <div
        className="galeria__slider"
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
      >
        {/* Slides */}
        {FOTOS.map((f, i) => (
          <div
            key={i}
            className={`galeria__slide ${i === current ? 'galeria__slide--active' : ''}`}
            aria-hidden={i !== current}
          >
            <img src={f.src} alt={f.alt} loading={i === 0 ? 'eager' : 'lazy'} />
            <div className="galeria__legenda">
              <span>{f.legenda}</span>
            </div>
          </div>
        ))}

        {/* Seta esquerda */}
        <button className="galeria__arrow galeria__arrow--prev" onClick={handlePrev} aria-label="Anterior">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>

        {/* Seta direita */}
        <button className="galeria__arrow galeria__arrow--next" onClick={handleNext} aria-label="Próxima">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>

        {/* Contador */}
        <div className="galeria__counter">
          {current + 1} / {FOTOS.length}
        </div>
      </div>

      {/* Thumbnails */}
      <div className="galeria__thumbs">
        {FOTOS.map((f, i) => (
          <button
            key={i}
            className={`galeria__thumb ${i === current ? 'galeria__thumb--active' : ''}`}
            onClick={() => { goTo(i); resetTimer(); }}
            aria-label={`Ir para foto ${i + 1}`}
          >
            <img src={f.src} alt={f.alt} loading="lazy" />
          </button>
        ))}
      </div>
    </section>
  );
}
